module.exports = __webpack_public_path__ + "img/logo3.cf234426.png";